var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 27") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dialogar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1feed-normal-copy-6",
    transform: "translate(-937.000000, -240.000000)",
    fill: "#EB5650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(472.000000, 225.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(465.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.31247115,7.85664423 L14.6560288,2.51308654 C15.0504519,2.11866346 15.0504519,1.47924038 14.6560288,1.08481731 C14.2622788,0.691067308 13.6228558,0.691067308 13.2284327,1.08481731 L7.884875,6.42904808 L2.54064423,1.08481731 C2.14689423,0.691067308 1.50747115,0.691067308 1.11304808,1.08481731 C0.718625,1.47924038 0.718625,2.11866346 1.11304808,2.51308654 L6.45727885,7.85664423 L1.11304808,13.2002019 C0.718625,13.594625 0.718625,14.2340481 1.11304808,14.6284712 C1.31025962,14.8256827 1.56872115,14.9239519 1.82718269,14.9239519 C2.08564423,14.9239519 2.34343269,14.8256827 2.54064423,14.6284712 L7.884875,9.28424038 L13.2284327,14.6284712 C13.4256442,14.8256827 13.6841058,14.9239519 13.9425673,14.9239519 C14.2010288,14.9239519 14.4588173,14.8256827 14.6560288,14.6284712 C15.0504519,14.2340481 15.0504519,13.594625 14.6560288,13.2002019 L9.31247115,7.85664423 Z",
    id: "Fill-29"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.04e0cabe86c70a1f9c36a2cd38793732.svg";
export { ForwardRef as ReactComponent };